export default __webpack_public_path__ + "static/media/No60.9cf001fc.png";